// extracted by mini-css-extract-plugin
export default {"container":"category_container__tMCTv","header":"category_header__RWmKM","body":"category_body__aZMWf","footer":"category_footer__Slo+A"};